module.exports = __webpack_public_path__ + "static/media/bradenTrainer.933cfcc1.png";